import GlobalStyles from "@mui/material/GlobalStyles";
import React, { useEffect } from "react";
import { ChatWidget } from "./src/components/chatWidget";
import Layout from "./src/components/layout";
import { setCookieItem } from "./src/shared/hooks/useCookie";
import { extractPartnerReferralFromUrl } from "./src/shared/utils"

const globalStyles =
  <GlobalStyles styles={(theme) => ({
    'body': {
      backgroundColor: 'white'
    },
    '#onetrust-pc-sdk button': {
      borderRadius: `20px!important`
    },
    blockquote: {
      borderLeft: '4px solid ' + theme.palette.primary.main,
      marginLeft: '11px',
      paddingLeft: '20px',
      paddingTop: '10px',
      paddingBottom: '10px',
      marginTop: '15px',
      marginBottom: '15px',
    },
    'blockquote p': {
      padding: '0',
      margin: '0',
      color: 'black',
      maxWidth: '800px',
      fontStyle: 'italic',
      whiteSpace: 'normal'
    }
  })} />

export default ({ element, props }) => {
  const { location } = props;

  useEffect(() => {
    const urlPartnerCode = extractPartnerReferralFromUrl(location.search)

    if (urlPartnerCode) {
      setCookieItem("seeka_partner_key", urlPartnerCode.code, 30)
      setCookieItem("seeka_partner_program", urlPartnerCode.programCode || '', 30)
    }
  }, [location.search])

  return (
    <>
      {globalStyles}
      <Layout {...props}>
        {element}
        <ChatWidget />
      </Layout>
    </>
  )
}
